import { axiosInstance } from "@/api/apiClient";
import {
  LiveWidgetApi,
  LiveWidgetApiAddonsViewsNinjaLiveWidgetGetWidgetSettingRequest,
  LiveWidgetApiAddonsViewsNinjaLiveWidgetWidgetCallSummaryRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";

const api = new LiveWidgetApi(undefined, BASE_API, axiosInstance);

export const getWidgetCallSummary = async (
  payload: LiveWidgetApiAddonsViewsNinjaLiveWidgetWidgetCallSummaryRequest
) => {
  return api.addonsViewsNinjaLiveWidgetWidgetCallSummary.bind(api)(payload);
};

export const getWidgetSetting = async (
  payload: LiveWidgetApiAddonsViewsNinjaLiveWidgetGetWidgetSettingRequest
) => {
  return api.addonsViewsNinjaLiveWidgetGetWidgetSetting.bind(api)(payload);
};
